/** Resolve the account email for the OTP step after a successful login initiation. */
export function resolveAccountEmailAfterLogin(
  response: { data?: { email?: string | null } | null },
  identifier: string,
): string | null {
  const fromApi = response.data?.email?.trim();
  if (fromApi) return fromApi;
  const trimmed = identifier.trim();
  if (trimmed.includes("@")) return trimmed;
  return null;
}
